<template>
  <el-form
    :model="form"
    ref="form">
    <h3 class="blue-text">{{L10n('close-po')}}</h3>
      <!-- content -->
    <div class="row">
      <div class="col-md-4 col-sm-6 col-12">
        <el-form-item
          :label="L10n('score')"
          prop="scoreID"
          :rules="orderRatingScoreRules"
          class="material-style"
        >
          <select-response
            :model.sync="form.scoreID"
            @on-change="autoSaveField('scoreID')"
            :data="dataSourceScore.records"
            :isLoading="dataSourceScore.loading"
          ></select-response>
        </el-form-item>
      </div>
      <div class="col-md-4 col-sm-6 col-12">
        <el-form-item
          prop="poStillOpen"
          class="material-style"
        >
          <el-checkbox
            v-model="form.poStillOpen"
            @change="autoSaveAndAlert('poStillOpen')"
          >
            {{L10n('po-still-open')}}
          </el-checkbox>
        </el-form-item>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 col-12">
        <el-form-item
          :rules="approvedForPaymentByEmployeeIDRules"
          :label="L10n('approved-for-payment-by-employee')"
          prop="approvedForPaymentByEmployeeID"
          class="material-style"
        >
          <select-response
            :model.sync="form.approvedForPaymentByEmployeeID"
            @on-change="autoSaveAndAlert('approvedForPaymentByEmployeeID')"
            :data="dataSourceEmployee.records"
            :isLoading="dataSourceEmployee.loading"
          ></select-response>
        </el-form-item>
      </div>
      <div class="col-md-4 col-12">
        <el-form-item
          :label="L10n('payment-remarks')"
          prop="paymentRemarks"
          class="material-style"
        >
          <el-input
            :value="form.paymentRemarks"
            @input="form.paymentRemarks = valueTrimLeft($event)"
            @change="autoSaveField('paymentRemarks')"
          />
        </el-form-item>
      </div>
      <div class="col-md-4 col-12">
        <el-form-item
          data-filed="true"
          class="material-style"
        >
          <ui-button type="button" class="btn btn-size-s btn-mobile-full" :disabled="!form.poStillOpen" @click="$emit('onClosePO')">
            {{L10n('close-po')}}
          </ui-button>
        </el-form-item>
      </div>
    </div>
  </el-form>
</template>

<script>
import Form from '@/components/Form/Form'

const SCORE_INDEX = 3

export default {
  name: 'FormClosePO',
  mixins: [Form],
  props: {
    isClosePoValidate: { type: Boolean, required: true }
  },
  watch: {
    isClosePoValidate () {
      this.clearValidate()
    }
  },
  computed: {
    dataSourceEmployee () {
      return this.API('Employees/GetAllDynamic?select=id,name as title&filter=isActive==true')
    },
    dataSourceScore () {
      return this.API(`Scores/GetAllDynamic?select=id,scoreText as title&filter=scoreIndex==${SCORE_INDEX}`)
    },
    orderRatingScoreRules () {
      if (!this.isClosePoValidate) {
        return []
      }
      return this.getValidationRule('required')
    },
    approvedForPaymentByEmployeeIDRules () {
      if (!this.isClosePoValidate) {
        return []
      }
      return this.getValidationRule('required')
    }
  },
  methods: {
    autoSaveAndAlert (field) {
      this.autoSaveField(field)
      this.$emit('onAlert')
    }
  }
}
</script>
